<template>
  <div>
    <HomePage />
  </div>
</template>

<script>

import HomePage from "./pages/HomePage";
export default {
  name: 'App',
  components:{
   HomePage,
  }
}
</script>

<style>
  @import "~bootstrap/dist/css/bootstrap.min.css";
  @import "~font-awesome/css/font-awesome.min.css";
  @import "~animate.css/animate.min.css";

  .bg-vue {
    background-color: rgb( 52, 73, 94 );
    color: #fff;
  }

  .bg-vue2 {
    background-color: rgb( 65, 184, 131 );
    color: #ffffff;
  }

  .text-vue {
    color: rgb( 52, 73, 94 );
  }

  .text-vue2 {
    color: rgb( 65, 184, 131 );
  }


</style>
